import { render, staticRenderFns } from "./Displays.vue?vue&type=template&id=5202b4b8&scoped=true&"
import script from "./Displays.vue?vue&type=script&lang=js&"
export * from "./Displays.vue?vue&type=script&lang=js&"
import style0 from "./Displays.vue?vue&type=style&index=0&id=5202b4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202b4b8",
  null
  
)

export default component.exports